export default "__VITE_ASSET__BNXx9ESw__"